import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {useResetUserMfa} from './useResetUserMfa';

type Props = {
    userId: number,
    onClose: () => void,
    onSuccess: () => void,
    onFail: () => void,
};

const MODAL_WIDTH = 450;

export const ResetUserMfaModal = ({userId, onClose, onSuccess, onFail}: Props) => {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const {event, busy: isUnlockBusy} = useResetUserMfa({
        userId,
        onSuccess,
        onFail: message => {
            setErrorMessage(message);
            onFail();
        },
    });

    const onResetClick = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Resetting Multi-Factor Authentication
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: MODAL_WIDTH}}>
                {errorMessage ? <Message color="error">{errorMessage}</Message> : null}
                <p>
                    Resetting Multi-Factor Authentication will remove the current authentication
                    methods for this user. They will need to set up MFA again to regain access.
                </p>
                <p>Are you sure you want to reset the MFA for this user?</p>
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button
                        variant="Type.PRIMARY"
                        busy={isUnlockBusy}
                        onClick={onResetClick}
                        disabled={!!errorMessage}>
                        Reset
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
